import axios from 'axios';

export const cardRedirectCall = async url => {
    const request = {
        method: 'GET',
        url,
    };
    const { data } = await axios(request);

    return data;
};
